stimulusApp.register(
  "room-tabs",
  class extends Stimulus.Controller {
    static targets = ["button", "tab"]
    static classes = ["selected"]

    change(event) {
      const tabId = event.params.id.toString()

      requestAnimationFrame(() => {
        this.buttonTargets.forEach((button) => {
          button.classList.toggle(
            this.selectedClass,
            button.dataset.roomTabsIdParam == tabId,
          )
        })

        this.tabTargets.forEach((tab) => {
          tab.classList.toggle("hidden", tab.dataset.tabId !== tabId)
        })
      })
    }
  },
)
